import withRCVProps from '../../hoc/with-rcv-props';
import { RichContentViewer } from '@wix/communities-blog-client-common/dist/esm/components';

export default withRCVProps(RichContentViewer);
